import React from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  CircularProgress,
  Divider,
  FormControl,
  Menu,
  MenuItem,
  Typography,
  useTheme,
  Box,
} from "@mui/material";
import TabSelection from "./TabSelection";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import BuildIcon from "@mui/icons-material/Build";
import { useEffect, useState, useRef } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../../store/store";
import Remediation_img from "../../../../assets/baseVersion/Remediation.svg";
import Audit_img from "../../../../assets/baseVersion/Audit_img.svg";
import References_img from "../../../../assets/baseVersion/References_img.svg";
import Rational_img from "../../../../assets/baseVersion/Rotional_img.svg";
import axiosInstance from "../../../../axios/axios";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import SkeletonLoader from "../../../../modules/dashboard/shared/skeleton_loader";
import ContentCopyIcon from "../../../../assets/copy_icon_sp.svg";
import ContentCopyDarkIcon from "../../../../assets/CopyContent_icon_dark.svg"


import { set } from "lodash";

const DetailsFlyout = ({
  Total_Resources,
  id,
  scanSummaryId,
  module: moduleProp,
  parameterType,
  controlType,
}: any) => {
  const location = useLocation();
  const isTemplate =
    parameterType?.toLowerCase() === "template" ||
    parameterType?.toLowerCase() === "custom";
  const [isRemediationexpanded, setIsRemediationExpanded] = useState(false);
  const [isAuditexpanded, setIsAuditExpanded] = useState(false);
  const [isRationaleexpanded, setIsRationaleExpanded] = useState(false);
  const [isReferencesexpanded, setIsReferencesExpanded] = useState(false);
  const [isAdditionalInformationexpanded, setIsAdditionalInformationExpanded] =
    useState(false);

  const [isdata, setData] = useState<any>();
  const [versionData, setVersionData] = useState<any>({});
  const [selectedValue, setSelectedValue] = useState("");
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [isVendor, setIsVendor] = useState("");
  const [isOs, setIsOs] = useState("");
  const [isVersion, setIsVersion] = useState("");
  const [loading, setLoading] = useState(false);
  const [isReady, setIsReady] = useState(false);
  const [showNoData, setShowNoData] = useState(false);
  const [copyFeedback, setCopyFeedback] = useState<string | null>(null);
  const [copiedBlockId, setCopiedBlockId] = useState<string | null>(null);

  const module =
    moduleProp === "on_premise" || moduleProp === "cloud"
      ? moduleProp
      : location.pathname.includes("onprem/scan") ||
          location.pathname.includes("on-premises")
        ? "on_premise"
        : "cloud";

  const Details_Data = useSelector(
    (state: any) => state.OnPrem_DetailsSelectedTab.selectedButton
  );
  // The selected tab's control category. controls-by-parameter filters on category
  // AND control type, so a MITRE or NIST tab queried as "Benchmark" never matches
  // (404). Unset (e.g. after a row click) keeps the old "Benchmark" behaviour.
  const Details_Category = useSelector(
    (state: { OnPrem_DetailsSelectedTab: { selectedCategory: string } }) =>
      state.OnPrem_DetailsSelectedTab.selectedCategory
  );
  const controlCategory: string = Details_Category || "Benchmark";
  const isBenchmarkTab = controlCategory === "Benchmark";
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === "dark";

  console.log(Details_Data, "versionData");
  const { scan_uuid: paramScanUuid } = useParams<{ scan_uuid: string }>();

  const { onprem_posture_id: reduxPostureId, scanType: reduxScanType } = useSelector(
    (state: RootState) => state.MyScanDetails
  );

  const scan_uuid = reduxScanType === "onprem_discovery_posture" && reduxPostureId 
    ? reduxPostureId 
    : paramScanUuid || scanSummaryId || reduxPostureId;

  useEffect(() => {
    let isCancelled = false;

    const resolveModifiedByNames = async (items: any[]) => {
      const userIds = Array.from(
        new Set(
          items
            .map((item) => item?.last_modified_by)
            .filter((userId) => typeof userId === "string" && userId.trim())
        )
      );
      if (userIds.length === 0) return items;

      try {
        const usersResponse = await axiosInstance.post(
          "authentication/org-users",
          { type: 1 }
        );
        const users: any[] =
          usersResponse.data?.data?.users_list ||
          usersResponse.data?.users_list ||
          (Array.isArray(usersResponse.data?.data)
            ? usersResponse.data.data
            : []) ||
          [];

        const nameById = users.reduce((acc: Record<string, string>, user: any) => {
          const userId = String(user?.id || "");
          const firstName =
            user?.firstname || user?.first_name || user?.firstName || "";
          if (userId && firstName) acc[userId] = firstName;
          return acc;
        }, {});

        return items.map((item) => ({
          ...item,
          last_modified_by_name:
            nameById[String(item?.last_modified_by || "")] ||
            item?.last_modified_by,
        }));
      } catch (error) {
        console.error("Error fetching org users for modified by:", error);
        return items;
      }
    };

    const fetchTemplateData = async () => {
      if (!id || !isTemplate) return;

      setLoading(true);
      setIsReady(false);
      setData(null);

      try {
        const response = await axiosInstance.get(
          "securityscan/control-parameters",
          {
            params: {
              parameter_name_id: id,
              control_type: "template",
              category_name: "Template",
              module: module,
              scan_summary_id: scan_uuid,
            },
          }
        );
        if (isCancelled) return;
        const rawData = response.data?.data || [];
        const enrichedData = await resolveModifiedByNames(rawData);
        if (isCancelled) return;
        setData(enrichedData);
      } catch (error) {
        console.error("Error fetching template control parameters:", error);
        if (!isCancelled) setData([]);
      } finally {
        if (!isCancelled) {
          setIsReady(true);
          setLoading(false);
        }
      }
    };

    if (isTemplate) {
      fetchTemplateData();
      return () => {
        isCancelled = true;
      };
    }
  }, [id, isTemplate, module, scan_uuid]);

  useEffect(() => {
    let isCancelled = false;

    const fetchData = async () => {
      if (!id || !Details_Data || isTemplate) return;

      setLoading(true);
      setIsReady(false);
      setData(null);

      try {
        const category_name = "Benchmark";
        const response = await axiosInstance.get(
          `securityscan/vendor-device-versions/${id}?module=${module}&category_name=${category_name}&scan_summary_id=${scan_uuid}`
        );
        if (isCancelled) return;

        const cisBenchVersions = response?.data?.data;

        // vendor-device-versions lists Benchmark checks only, so a cloud Framework/MITRE
        // tab must not wait for it: cloud controls are fetched for the vendor as a whole.
        if (
          (cisBenchVersions && Object.keys(cisBenchVersions).length > 0) ||
          (module === "cloud" && !isBenchmarkTab)
        ) {
          if (module !== "cloud") {
            const filteredVersions: Record<
              string,
              Record<
                string,
                Array<{ version: string; control_display_name: string }>
              >
            > = {};

            Object.entries(cisBenchVersions).forEach(([vendor, osData]) => {
              const filteredOsData: Record<
                string,
                Array<{ version: string; control_display_name: string }>
              > = {};

              Object.entries(
                osData as Record<
                  string,
                  Array<{ version: string; control_display_name: string }>
                >
              ).forEach(([os, versions]) => {
                // A Benchmark tab keeps only its own checks' versions. Framework/MITRE
                // controls have no entry of their own here, so any of the parameter's
                // vendor/OS/version rows scopes them; list each version once.
                const matchingVersions = isBenchmarkTab
                  ? versions.filter(
                      (v) => v.control_display_name === Details_Data?.toUpperCase()
                    )
                  : versions.filter(
                      (v, i, all) => all.findIndex((o) => o.version === v.version) === i
                    );
                if (matchingVersions.length > 0) {
                  filteredOsData[os] = matchingVersions;
                }
              });

              if (Object.keys(filteredOsData).length > 0) {
                filteredVersions[vendor] = filteredOsData;
              }
            });

            if (isCancelled) return;
            setVersionData(filteredVersions);

            const firstValue = Object.entries(filteredVersions).flatMap(
              ([vendor, osData]) =>
                Object.entries(osData).flatMap(([os, versions]) =>
                  versions.map(
                    (versionObj) => `${vendor} - ${os} - ${versionObj.version}`
                  )
                )
            )[0];

            if (firstValue) {
              const [vendor, os, version] = firstValue
                .split(" - ")
                .map((v: string) => v.trim());
              if (!isCancelled) {
                setSelectedValue(firstValue);
                setIsVendor(vendor);
                setIsOs(os);
                setIsVersion(version);
              }
              try {
                const response = await axiosInstance.get(
                  "securityscan/control-parameters",
                  {
                    params: {
                      control_type: Details_Data?.toUpperCase(),
                      category_name: controlCategory,
                      vendor: vendor,
                      model: os,
                      version: version,
                      parameter_name_id: id,
                      module: module,
                      scan_summary_id: scan_uuid,
                    },
                  }
                );

                if (isCancelled) return;
                setData(response.data?.data || []);
              } catch (error) {
                console.error("Error fetching data:", error);
                if (!isCancelled) setData([]);
              } finally {
                if (!isCancelled) setIsReady(true);
              }
            } else {
              if (!isCancelled) {
                setData([]);
                setIsReady(true);
              }
            }
          } else {
            try {
              if (!isCancelled) {
                setIsVendor("amazon web services");
                setSelectedValue("amazon web services");
              }
              const response = await axiosInstance.get(
                "securityscan/control-parameters",
                {
                  params: {
                    control_type: Details_Data?.toUpperCase(),
                    category_name: controlCategory,
                    vendor: "amazon web services",
                    parameter_name_id: id,
                    scan_summary_id: scan_uuid,
                    module: module,
                  },
                }
              );

              if (isCancelled) return;
              setData(response.data?.data || []);
            } catch (error) {
              console.error("Error fetching data:", error);
              if (!isCancelled) setData([]);
            } finally {
              if (!isCancelled) setIsReady(true);
            }
          }
        } else {
          if (!isCancelled) {
            setVersionData({});
            setData([]);
            setIsReady(true);
          }
        }
      } catch (error) {
        console.error("Error fetching CIS bench versions:", error);
        if (!isCancelled) {
          setVersionData({});
          setData([]);
          setIsReady(true);
        }
      } finally {
        if (!isCancelled) setLoading(false);
      }
    };

    fetchData();

    return () => {
      isCancelled = true;
    };
  }, [id, Details_Data, controlCategory, isBenchmarkTab, isTemplate]);

  useEffect(() => {
    if (isReady && (!isdata || isdata.length === 0)) {
      const timer = setTimeout(() => setShowNoData(true), 1500);
      return () => clearTimeout(timer);
    } else {
      setShowNoData(false);
    }
  }, [isReady, isdata]);

  console.log(versionData, "versionDataversionDataversionData");

  // Flatten versionData into a simple list of "vendor - os - version" strings
  const versionOptions = React.useMemo(
    () =>
      Object.entries(versionData || {}).flatMap(([vendor, osData]) =>
        Object.entries(osData || {}).flatMap(([os, versions]) =>
          Array.isArray(versions)
            ? versions.map((versionObj: { version: string }) =>
                `${vendor} - ${os} - ${versionObj.version}`
              )
            : []
        )
      ),
    [versionData]
  );

  const handleMenuOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const activeSelectReqId = useRef(0);

  const handleSelectValue = async (value: string) => {
    const reqId = ++activeSelectReqId.current;
    const individualValues = value.split(" - ").map((v) => v.trim());

    setSelectedValue(value);
    const [vendor, os, version] = individualValues;

    if (individualValues) {
      setLoading(true);
      setIsReady(false);
      setData(null);
      try {
        const params: any = {
          control_type: Details_Data?.toUpperCase(),
          category_name: controlCategory,
          parameter_name_id: id,
          module: module,
          scan_summary_id: scan_uuid,
        };

        if (vendor) params.vendor = vendor;
        if (os) params.model = os;
        if (version) params.version = version;

        const response = await axiosInstance.get("securityscan/control-parameters", {
          params,
        });

        if (reqId !== activeSelectReqId.current) return;
        setData(response.data?.data || []);
      } catch (error: any) {
        console.error("Error fetching data:", error);
        if (reqId === activeSelectReqId.current) setData([]);
      } finally {
        if (reqId === activeSelectReqId.current) {
          setIsReady(true);
          setLoading(false);
        }
      }

      if (reqId === activeSelectReqId.current) {
        setIsVendor(vendor || "");
        setIsOs(os || "");
        setIsVersion(version || "");
      }
    }

    handleMenuClose();
  };

  const attributeMappings: Record<string, Record<string, string>> = {
    SPARK: {
      name: "Spark Name",
      description: "Spark Descreption",
      remediation: "SPARK Remediation UI",
      audit: "SPARK Audit",
      rationale: "SPARK Rationale",
      references: "SPARK Reference",
    },
    CIS: {
      name: "CIS Name",
      description: "CIS Descreption UI",
      remediation: "CIS Remediation UI",
      audit: "CIS Audit UI",
      rationale: "CIS Rationale UI",
      references: "CIS Reference",
      level: "CIS Level",
    },
    DISA: {
      name: "DISA Name",
      description: "DISA Description",
      remediation: "DISA Remediation UI",
      audit: "DISA Audit",
      rationale: "DISA Rationale",
      references: "DISA Reference",
    },
  };

  const scanType = Details_Data?.toUpperCase() || "SPARK"; // default fallback to SPARK
  const fieldMap = attributeMappings[scanType] || attributeMappings["SPARK"];

  const formatTemplateSectionUi = (sectionUi: any) => {
    if (!sectionUi || typeof sectionUi !== "object") return "";
    const parts: string[] = [];
    if (sectionUi.title) parts.push(sectionUi.title);
    if (sectionUi.description) parts.push(sectionUi.description);
    if (sectionUi.command) parts.push(`\`\`\`\n${sectionUi.command}\n\`\`\``);
    return parts.join("\n\n");
  };

  const mapTemplateToDetails = (item: any) => {
    const vendorModel = [item.vendor, item.device_model]
      .filter(Boolean)
      .join(" - ");
    const modifiedByName =
      item.last_modified_by_name || item.last_modified_by || "";
    const remediationContent =
      formatTemplateSectionUi(item.remediation_ui) ||
      (item.Remediation ? `\`\`\`\n${item.Remediation}\n\`\`\`` : "");
    const auditContent =
      formatTemplateSectionUi(item.audit_ui) ||
      (item.Audit ? `\`\`\`\n${item.Audit}\n\`\`\`` : "");
    const referenceParts = [
      item.template_name ? `Template name: ${item.template_name}` : "",
      item.last_modified
        ? `Last modified: ${new Date(item.last_modified).toLocaleString()}`
        : "",
      modifiedByName ? `Last modified by: ${modifiedByName}` : "",
    ].filter(Boolean);

    return {
      id: item.parameter_name_id,
      compliance_id: "",
      name:
        item.remediation_ui?.parent_command ||
        item.parent_command ||
        "Template Command",
      description: "",
      level: vendorModel || "N/A",
      remediation: remediationContent,
      hasChildCommands: Boolean(remediationContent),
      hasAuditInfo: Boolean(auditContent),
      hasReferences: referenceParts.length > 0,
      audit: auditContent,
      rationale: "",
      references: referenceParts.join("\n"),
      additional_information: "",
    };
  };


  const Scan_Details_Data = Array.isArray(isdata)
    ? isTemplate
      ? isdata.map(mapTemplateToDetails)
      : isdata.map((item: any) => ({
          id: item.id,
          compliance_id: item.version_number,
          name: item.attributes?.[fieldMap.name],
          description:
            item.attributes?.[fieldMap.description]?.replace(/_x000D_/g, "") ||
            "",
          level: item.attributes?.[fieldMap.level],
          remediation:
            item.attributes?.[fieldMap.remediation]?.replace(/_x000D_/g, "") ||
            "",
          audit:
            item.attributes?.[fieldMap.audit]?.replace(/_x000D_/g, "") || "",
          rationale:
            item.attributes?.[fieldMap.rationale]?.replace(/_x000D_/g, "") ||
            "",
          references:
            item.attributes?.[fieldMap.references]?.replace(/_x000D_/g, "") ||
            "",
          additional_information: item.additional_information,
        }))
    : [];

  function formatText(text: string, section: string = 'default') {
    if (!text) return null;

    // Clean up _x000D_ characters (carriage return in XML/HTML encoding)
    text = text.replace(/_x000D_/g, '');

    // Split the text into parts based on triple backticks (code blocks), @@@ patterns, triple single quotes, single quotes, and $$ patterns
    // Updated to handle mixed quote delimiters (''...''', '''...''', ''...'', and '...') and $$ delimiter
    const parts = text.split(/(```[\s\S]*?```|\$\$[\s\S]*?\$\$|''[^'@]*?@@@[\s\S]*?'''|''[^'@]*?'''|@@@[\s\S]*?@@@|'''[\s\S]*?'''|''[\s\S]*?''|'[^'\s@][\s\S]*?'|\*\*\*[\s\S]*?\*\*\*)/g);

    // Debug: log the parts to see what's being processed
    console.log('formatText parts:', parts);

    const handleCopyCode = async (codeContent: string, blockId: string) => {
      try {
        await navigator.clipboard.writeText(codeContent.trim());
        setCopiedBlockId(blockId);
        setCopyFeedback("✓ Copied!");
        setTimeout(() => {
          setCopyFeedback(null);
          setCopiedBlockId(null);
        }, 2000);
      } catch (err) {
        console.error('Failed to copy code: ', err);
        // Fallback for older browsers
        const textArea = document.createElement("textarea");
        textArea.value = codeContent.trim();
        document.body.appendChild(textArea);
        textArea.select();
        try {
          document.execCommand("copy");
          setCopiedBlockId(blockId);
          setCopyFeedback("✓ Copied!");
          setTimeout(() => {
            setCopyFeedback(null);
            setCopiedBlockId(null);
          }, 2000);
        } catch (fallbackErr) {
          console.error("Fallback copy failed: ", fallbackErr);
          setCopyFeedback("✗ Copy failed");
          setTimeout(() => {
            setCopyFeedback(null);
            setCopiedBlockId(null);
          }, 2000);
        }
        document.body.removeChild(textArea);
      }
    };

    return parts.map((part: string, index: number) => {
      if (index % 2 === 1) {
        // Code block from triple backticks, $$, triple asterisks, @@@, triple single quotes, or double single quotes
        let codeContent = part;
        if (part.startsWith('```') && part.endsWith('```')) {
          codeContent = part.slice(3, -3); // Remove ``` from start and end
        } else if (part.startsWith('$$') && part.endsWith('$$')) {
          codeContent = part.slice(2, -2); // Remove $$ from start and end
        } else if (part.startsWith("***") && part.endsWith("***")) {
          codeContent = part.slice(3, -3); // Remove *** from start and end
        } else if (part.startsWith("''") && part.endsWith("'''")) {
          codeContent = part.slice(3, -3); // Remove '' from start and ''' from end
        } else if (part.startsWith("'''") && part.endsWith("'''")) {
          codeContent = part.slice(3, -3); // Remove ''' from start and ''' from end
        } else if (part.startsWith('@@@') && part.endsWith('@@@')) {
          codeContent = part.slice(3, -3); // Remove @@@ from start and end
        } else if (part.startsWith("''") && part.endsWith("''")) {
          codeContent = part.slice(2, -2); // Remove '' from start and end
        } else if (part.startsWith("'") && part.endsWith("'") && part.length > 1) {
          codeContent = part.slice(1, -1); // Remove ' from start and end
        }

        const copyContent = codeContent.split('@@@')[1] || codeContent;
        codeContent = codeContent.replace(/@@@/g, "");

        // Create a unique block ID combining section and index
        const blockId = `${section}-${index}`;

        return (
          <div
            key={`codeblock-${blockId}`}
            style={{
              position: "relative",
              backgroundColor: isDarkMode ? "#transparent" : "#E5E5FC",
              borderRadius: "6px",
              margin: "12px 0",
              overflow: "hidden",
            }}
          >
            <div
              style={{
                position: "absolute",
                top: "8px",
                right: "8px",
                zIndex: 1,
                cursor: copiedBlockId === blockId ? "default" : "pointer",
                padding: "4px",
                borderRadius: "4px",
                // backgroundColor: isDarkMode ? "rgba(255,255,255,0.1)" : "rgba(0,0,0,0.1)",
                transition: "background-color 0.2s",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
              onClick={copiedBlockId === blockId ? undefined : () => handleCopyCode(copyContent, blockId)}
              title={copiedBlockId === blockId ? "Copied!" : "Copy code"}
            >
              {copiedBlockId === blockId ? (
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#4CAF50"
                  strokeWidth="3"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  style={{ display: "block" }}
                >
                  <polyline points="20 6 9 17 4 12" />
                </svg>
              ) : (
                <img
                  src={isDarkMode ? ContentCopyDarkIcon : ContentCopyIcon}
                  alt="Copy"
                  style={{
                    width: "16px",
                    height: "16px",
                    cursor: "pointer",
                    opacity: 0.4,
                    transition: "opacity 0.2s ease",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.opacity = "1";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.opacity = "0.4";
                  }}
                />
              )}
            </div>
            <pre
              style={{
                padding: "12px",
                paddingTop: "40px", // Extra padding to accommodate the copy button
                borderRadius: "6px",
                overflowX: "auto",
                overflowY: "auto",
                fontFamily: "monospace",
                fontSize: "13px",
                lineHeight: 1.4,
                whiteSpace: "pre-wrap",
                wordBreak: "break-all",
                maxWidth: "100%",
                margin: 0,
              }}
            >
              <code style={{
                color: isDarkMode ? "#E6DB74" : "#2E7D32",
                whiteSpace: "pre-wrap",
                wordBreak: "break-all",
                display: "block",
              }}>
                {codeContent.trim()}
              </code>
            </pre>
          </div>

        );
      } else {
        // Process regular text for bold formatting and other patterns
        const lines = part.split("\n");
        return lines.map((line: string, lineIndex: number) => {
          // Check if this line is a heading (starts with #)
          const headingMatch = line.match(/^(#+)\s+(.+)$/);
          if (headingMatch) {
            const headingLevel = headingMatch[1].length;
            const headingText = headingMatch[2];
            return (
              <div key={`heading-${index}-${lineIndex}`} style={{
                marginBottom: "8px",
                marginTop: "12px",
                fontWeight: "bold",
                fontSize: headingLevel === 1 ? "18px" : headingLevel === 2 ? "16px" : "14px",
                color: isDarkMode ? "#E0E0E0" : "#333333"
              }}>
                {headingText}
              </div>
            );
          }

          // Process bold text (**text**)
          const boldPattern = /\*\*(.*?)\*\*/g;
          const urlPattern = /(https?:\/\/[^\s<>"{}|\\^`\[\]]+)/gi;
          const cisPattern = /(CIS Reference:\s?[^\s]+)/gi;
          const atPattern = /(@\S+)/g;
          // Hash pattern - but exclude command prompts like "hostname#command"
          const hashPattern = /(\s)(#[^\s]+)/g;

          // First, split by bold pattern
          const boldParts = line.split(boldPattern);

          // Debug: log bold parts to see if bold text is being detected
          if (boldParts.length > 1) {
            console.log('Bold parts detected:', boldParts);
          }

          return (
            <div key={`line-${index}-${lineIndex}`} style={{ marginBottom: "4px" }}>
              {boldParts.map((boldPart: string, boldIndex: number) => {
                if (boldIndex % 2 === 1) {
                  // This is bold text
                  return (
                    <strong key={`bold-${index}-${lineIndex}-${boldIndex}`}>
                      {boldPart}
                    </strong>
                  );
                } else {
                  // Process non-bold text for other patterns
                  const combinedPattern = /(https?:\/\/[^\s<>"{}|\\^`\[\]]+|CIS Reference:\s?[^\s]+|@\S+|#[^\s]+)/g;
                  const subParts = boldPart.split(combinedPattern);

                  return subParts.map((sub: string, subIndex: number) => {
                    if (urlPattern.test(sub)) {
                      return (
                        <a
                          key={`url-${index}-${lineIndex}-${boldIndex}-${subIndex}`}
                          href={sub}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{
                            color: isDarkMode ? "#90CAF9" : "#1976D2",
                            textDecoration: "underline",
                            wordBreak: "break-all"
                          }}
                        >
                          {sub}
                        </a>
                      );
                    } else if (cisPattern.test(sub)) {
                      const url = sub.replace("CIS Reference:", "").trim();
                      return (
                        <a
                          key={`cis-${index}-${lineIndex}-${boldIndex}-${subIndex}`}
                          href={url}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{
                            color: isDarkMode ? "#90CAF9" : "#1976D2",
                            textDecoration: "underline"
                          }}
                        >
                          {sub}
                        </a>
                      );
                    } else if (atPattern.test(sub)) {
                      // Extract content after @ symbol and clean up any delimiters or temporary markers
                      let cleanText = sub.replace(/^@+/, '').replace(/___TEMP_AT[A-Z_]*/g, '').replace(/@+$/, '');
                      return (
                        <code
                          key={`at-${index}-${lineIndex}-${boldIndex}-${subIndex}`}
                          style={{
                            backgroundColor: isDarkMode ? "#transparent" : "#E5E5FC",
                            padding: "2px 4px",
                            borderRadius: "4px",
                            fontFamily: "monospace",
                            marginRight: "4px",
                            color: isDarkMode ? "#E6DB74" : "#2E7D32",
                            wordBreak: "break-all",
                          }}
                        >
                          {cleanText}
                        </code>
                      );
                    } else if (hashPattern.test(sub)) {
                      return (
                        <React.Fragment key={`hash-${index}-${lineIndex}-${boldIndex}-${subIndex}`}>
                          <br />
                          <span>{sub.trim()}</span>
                        </React.Fragment>
                      );
                    } else {
                      return <span key={`text-${index}-${lineIndex}-${boldIndex}-${subIndex}`}>{sub}</span>;
                    }
                  });
                }
              })}
            </div>
          );
        });
      }
    });
  }


  return (
    <div style={{ paddingLeft: 15 }}>
      <div style={{ display: "flex", flexDirection: "row", gap: 40 }}>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            gap: 20,
            alignItems: "center",
          }}
        >
          <Typography variant="body2" sx={{ fontWeight: "bold" }}>
            Total Resources
          </Typography>
          <span style={{ color: "#3A2ADA", fontWeight: 600, fontSize: "24px" }}>
            {Total_Resources?.devices_count}
          </span>
        </div>
        <Divider
          variant="middle"
          orientation="vertical"
          flexItem
          sx={{ height: "50px", color: "#D2D2F6" }}
        />
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            gap: 20,
            alignItems: "center",
          }}
        >
          <Typography variant="body2" sx={{ fontWeight: "bold" }}>
            Failed
          </Typography>
          <span style={{ color: "#F53B3B", fontWeight: 600, fontSize: "24px" }}>
            {Total_Resources?.failed_count}
          </span>
        </div>
        <Divider variant="middle" orientation="vertical" flexItem />
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            gap: 15,
            alignItems: "center",
          }}
        >
          <Typography variant="body2" sx={{ fontWeight: "bold" }}>
            Pass
          </Typography>
          <span style={{ color: "#00A61B", fontWeight: 600, fontSize: "24px" }}>
            {Total_Resources?.passed_count}
          </span>
        </div>
        <Divider variant="middle" orientation="vertical" flexItem />
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            gap: 15,
            alignItems: "center",
          }}
        >
          <Typography variant="body2" sx={{ fontWeight: "bold" }}>
            Accepted Risk
          </Typography>
          <span style={{ color: "#BB2B3D", fontWeight: 600, fontSize: "24px" }}>
            {isTemplate ? "N/A" : Total_Resources?.accepted_count}
          </span>
        </div>
      </div>

      <>
          <Divider sx={{ mb: 2 }} />
          <div
            style={{
              marginBottom: 10,
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <TabSelection
              setLoading={setLoading}
              module={module}
              id={id}
              parameterType={parameterType}
              controlType={controlType}
            />
        {!isTemplate && (
        <FormControl sx={{ width: "150px" }}>
          <Button
            variant="outlined"
            onClick={versionOptions.length > 1 ? handleMenuOpen : undefined}
            endIcon={versionOptions.length > 1 ? <KeyboardArrowDownIcon /> : undefined}
            sx={{
              backgroundColor: isDarkMode ? "#1E1E1E" : "#F8F8FF", // Light background for the button
              color: isDarkMode ? "white" : "#3A2ADA", // Text color
              fontWeight: "bold",
              cursor: versionOptions.length > 1 ? "pointer" : "default",
              "&:hover": {
                backgroundColor: isDarkMode ? "#1E1E1E" : "#E0E0FF", // Hover effect for the button
              },
            }}
          >
            {selectedValue || "Select Version"}
          </Button>
          {module !== "cloud" && versionOptions.length > 1 && (
            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleMenuClose}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "left",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "left",
              }}
              sx={{
                "& .MuiPaper-root": {
                  backgroundColor: isDarkMode ? "#1E1E1E" : "#F8F8FF", // Dropdown background
                  borderRadius: "4px", // Rounded corners
                  boxShadow: "0px 4px 5px rgba(0, 0, 0, 0.25)", // Shadow for the dropdown
                },
              }}
            >
              {versionOptions.map((combinedValue) => (
                <MenuItem
                  key={combinedValue}
                  onClick={() => handleSelectValue(combinedValue)}
                  sx={{
                    "&:hover": {
                      backgroundColor: "#E0E0FF", // Hover effect for menu items
                      color: "#3A2ADA", // Text color on hover
                    },
                    fontWeight: "bold",
                  }}
                >
                  {combinedValue}
                </MenuItem>
              ))}
            </Menu>
          )}
        </FormControl>
        )}
      </div>
      <div>
        <Divider sx={{ mb: 2 }} />
        {!isReady || loading || !isdata || (!showNoData && isdata.length === 0) ? (
          <Box>
            <SkeletonLoader
              count={Math.floor(window.innerHeight / 45)}
              styles={{ height: 20 }}
            />
          </Box>
        ) : isdata && isdata.length > 0 ? (
          <div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                gap: 10,
                marginBottom: 5,
                alignItems: "center",
              }}
            >
              <div style={{ display: "flex", flexDirection: "row", gap: 10 }}>
                {Scan_Details_Data[0]?.compliance_id && (
                  <Typography
                    variant="body2"
                    sx={{
                      color: "#3A2ADA",
                      fontWeight: "bolder",
                      fontSize: "16px",
                    }}
                  >
                    <span
                      style={{
                        backgroundColor: isDarkMode ? "#1E1E1E" : "#B6B6B626",
                        padding: 5,
                        borderRadius: 4,
                      }}
                    >
                      {Scan_Details_Data[0]?.compliance_id}
                    </span>
                  </Typography>
                )}
                <Typography
                  variant="body2"
                  sx={{ fontWeight: "bold", fontSize: "16px" }}
                >
                  {Scan_Details_Data[0]?.name}
                </Typography>
              </div>
              <div style={{ display: "flex", justifyContent: "flex-end" }}>
                <Typography
                  variant="body2"
                  sx={{
                    fontWeight: "bold",
                    fontSize: "14px",
                    color: "#3A2ADA",
                    backgroundColor: "#1103C014",
                    padding: 1,
                    borderRadius: 1,
                    textWrap: "nowrap",
                  }}
                >
                  {Scan_Details_Data[0]?.level || "N/A"}
                </Typography>{" "}
              </div>
            </div>
            {Scan_Details_Data[0]?.description && (
              <Typography variant="body2" sx={{ color: "#716DA0", mb: 2 }}>
                {Scan_Details_Data[0]?.description}
              </Typography>
            )}
            {(Scan_Details_Data[0]?.remediation || isTemplate) && (
              <Accordion
                expanded={isRemediationexpanded}
                onChange={() =>
                  setIsRemediationExpanded(!isRemediationexpanded)
                }
                sx={{
                  border: "1px solid #ccc",
                  borderRadius: "8px",
                  overflow: "hidden",
                  "&:before": { display: "none" },
                  mb: 2,
                }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  sx={{
                    borderRadius: "8px",
                    bgcolor: isDarkMode ? "transparent" : "#F8F8FF",
                  }}

                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 12,
                    }}
                  >
                    <div
                      style={{
                        width: 40,
                        height: 40,
                        borderRadius: "50%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <img
                        src={Remediation_img}
                        alt=""
                        style={{ width: 20, height: 20 }}
                      />
                    </div>

                    <Typography variant="subtitle1" fontWeight="bold">
                      Remediation:
                    </Typography>
                  </div>
                </AccordionSummary>

                <AccordionDetails
                  sx={{
                    borderRadius: "8px",
                    overflow: "hidden",
                    bgcolor: isDarkMode ? "transparent" : "#F8F8FF",
                    padding: 2,
                  }}
                >
                  {isTemplate && !Scan_Details_Data[0]?.hasChildCommands ? (
                    <Typography variant="body2" sx={{ color: "#716DA0" }}>
                      No remediation details are available for this template.
                    </Typography>
                  ) : (
                    formatText(Scan_Details_Data[0]?.remediation, 'remediation')
                  )}
                </AccordionDetails>
              </Accordion>
            )}

            {(Scan_Details_Data[0]?.audit || isTemplate) && (
              <Accordion
                expanded={isAuditexpanded}
                onChange={() => setIsAuditExpanded(!isAuditexpanded)}
                sx={{
                  border: "1px solid #ccc",
                  borderRadius: "8px",
                  overflow: "hidden",
                  "&:before": { display: "none" },
                  mb: 2,
                }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  sx={{
                    borderRadius: "8px",
                    bgcolor: isDarkMode ? "transparent" : "#F8F8FF",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                    }}
                  >
                    <div
                      style={{
                        width: 40,
                        height: 40,
                        borderRadius: "50%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <img
                        src={Audit_img}
                        alt=""
                        style={{ width: 20, height: 20 }}
                      />
                    </div>
                    <Typography variant="subtitle1" fontWeight="bold">
                      Audit:
                    </Typography>
                  </div>
                </AccordionSummary>
                <AccordionDetails
                  sx={{
                    borderRadius: "8px",
                    bgcolor: isDarkMode ? "transparent" : "#F8F8FF",
                    overflow: "hidden",
                    padding: 2,
                  }}
                >
                  {isTemplate && !Scan_Details_Data[0]?.hasAuditInfo ? (
                    <Typography variant="body2" sx={{ color: "#716DA0" }}>
                      No audit details are available for this template.
                    </Typography>
                  ) : (
                    formatText(Scan_Details_Data[0]?.audit, 'audit')
                  )}
                </AccordionDetails>
              </Accordion>
            )}

            {!isTemplate && Scan_Details_Data[0]?.rationale && (
              <Accordion
                expanded={isRationaleexpanded}
                onChange={() => setIsRationaleExpanded(!isRationaleexpanded)}
                sx={{
                  border: "1px solid #ccc",
                  borderRadius: "8px",
                  overflow: "hidden",
                  "&:before": { display: "none" },
                  mb: 2,
                }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  sx={{
                    borderRadius: "8px",
                    bgcolor: isDarkMode ? "transparent" : "#F8F8FF",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                    }}
                  >
                    <div
                      style={{
                        width: 40,
                        height: 40,
                        borderRadius: "50%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <img
                        src={Rational_img}
                        alt=""
                        style={{ width: 20, height: 20 }}
                      />
                    </div>
                    <Typography variant="subtitle1" fontWeight="bold">
                      Rationale:
                    </Typography>
                  </div>
                </AccordionSummary>
                <AccordionDetails
                  sx={{
                    borderRadius: "8px",
                    bgcolor: isDarkMode ? "transparent" : "#F8F8FF",
                    overflow: "hidden",
                    padding: 2,
                  }}
                >
                  {formatText(Scan_Details_Data[0]?.rationale, 'rationale')}
                </AccordionDetails>
              </Accordion>
            )}

            {(Scan_Details_Data[0]?.references || isTemplate) && (
              <Accordion
                expanded={isReferencesexpanded}
                onChange={() => setIsReferencesExpanded(!isReferencesexpanded)}
                sx={{
                  border: "1px solid #ccc",
                  borderRadius: "8px",
                  overflow: "hidden",
                  "&:before": { display: "none" },
                  mb: 2,
                }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  sx={{
                    borderRadius: "8px",
                    bgcolor: isDarkMode ? "transparent" : "#F8F8FF",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                    }}
                  >
                    <div
                      style={{
                        width: 40,
                        height: 40,
                        borderRadius: "50%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <img
                        src={References_img}
                        alt=""
                        style={{ width: 20, height: 20 }}
                      />
                    </div>
                    <Typography variant="subtitle1" fontWeight="bold">
                      References:
                    </Typography>
                  </div>
                </AccordionSummary>
                <AccordionDetails
                  sx={{
                    borderRadius: "8px",
                    overflow: "hidden",
                    bgcolor: isDarkMode ? "transparent" : "#F8F8FF",
                    padding: 2,
                  }}
                >
                  {isTemplate && !Scan_Details_Data[0]?.hasReferences ? (
                    <Typography variant="body2" sx={{ color: "#716DA0" }}>
                      No references are available for this template.
                    </Typography>
                  ) : (
                    formatText(Scan_Details_Data[0]?.references, 'references')
                  )}
                </AccordionDetails>
              </Accordion>
            )}
            {!isTemplate && Scan_Details_Data[0]?.additional_information && (
              <Accordion
                expanded={isAdditionalInformationexpanded}
                onChange={() =>
                  setIsAdditionalInformationExpanded(
                    !isAdditionalInformationexpanded
                  )
                }
                sx={{
                  border: "1px solid #ccc",
                  borderRadius: "8px",
                  overflow: "hidden",
                  "&:before": { display: "none" },
                }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  sx={{
                    borderRadius: "8px",
                  }}
                >
                  <Typography variant="subtitle1" fontWeight="bold">
                    Additional Information:
                  </Typography>
                </AccordionSummary>
                <AccordionDetails
                  sx={{
                    borderRadius: "8px",
                    overflow: "hidden",
                  }}
                >
                  {Scan_Details_Data[0]?.additional_information}
                </AccordionDetails>
              </Accordion>
            )}
          </div>
        ) : (
          <Typography
            variant="body2"
            sx={{
              color: "000", // Red color for the message
              textAlign: "center",
              marginTop: 20,
            }}
          >
            No data found
          </Typography>
        )}
      </div>
      </>
    </div>
  );
};

export default DetailsFlyout;
